export default "__VITE_ASSET__9Sc7EeYo__"